<script setup>
import { computed, defineProps, onMounted, ref } from "vue";
import { FINANCIAL_AID_INFO_LINK as financialAidInfoUrl } from "@/constants";

defineProps({
  program: {
    type: Object,
    required: true,
  },
  session: {
    type: Object,
    required: true,
  },
});

const marketoScriptDomain = String(import.meta.env.VITE_MARKETO_SCRIPT_DOMAIN ?? "");
const marketoAccountId = String(import.meta.env.VITE_MARKETO_ACCOUNT_ID ?? "");
const marketoScholarshipFormId = String(import.meta.env.VITE_MARKETO_SCHOLARSHIP_FORM_ID ?? "");

const hasMinimumDataToMountForm = computed(
  () => marketoScriptDomain !== "" && marketoAccountId !== "" && marketoScholarshipFormId !== "",
);

const marketoFormBaseUrl = computed(() => {
  const host = marketoScriptDomain.replace(/^\/+/, "");
  return `//${host}`;
});

const mktoFormElementId = computed(() => `mktoForm_${marketoScholarshipFormId}`);

const mountMarketo = () => {
  // Checks if we should mount marketo
  if (!hasMinimumDataToMountForm.value) {
    return false;
  }

  const { MktoForms2 } = window;
  if (typeof MktoForms2?.loadForm !== "function") {
    return false; // Marketo script is not loaded.
  }

  return true;
};

const showSuccessMessage = ref(false);

onMounted(() => {
  if (mountMarketo()) {
    MktoForms2.loadForm(marketoFormBaseUrl.value, marketoAccountId, marketoScholarshipFormId, (form) => {
      form.onSuccess(() => {
        showSuccessMessage.value = true;

        // Manually change button text
        const [submitButton] = document.querySelectorAll(".mktoButton");
        if (submitButton) {
          submitButton.innerText = "Submitted";
        }

        return false; // Avoids refreshing page on submission.
      });
    });
  }
});
</script>
<template>
  <div
    class="pt-12 md:pt-20 border-b border-gray-200 md:px-8 text-indigo-base relative h-fit"
  >
    <div>
      <div>
        <div class="pb-8">
          <div class="text-indigo-base font-bold text-1xl">
            <h2 class="text-2xl">Financial Aid</h2>
            <p>SCHOLARSHIPS</p>
          </div>
        </div>
        <div class="text-sm font-medium">
          <p>
            Yes, you can use your financial aid for our programs! Learn more about that
            <a
              :href="financialAidInfoUrl"
              target="_blank"
              :class="[
                secondaryColor ? `${secondaryColorClassLinks}` : 'api-link',
              ]"
              >here</a
            >. In addition, API provides millions of dollars in scholarships to students
            every year.
            <span v-if="hasMinimumDataToMountForm">
              If you'd like to learn more about our scholarships, enter your email below.
            </span>
          </p>
        </div>
        <form v-if="hasMinimumDataToMountForm" :id="mktoFormElementId"></form>
        <div v-if="showSuccessMessage" class="col-span-2 text-university-secondary">
          Success! Be on the look out for more information on scholarship opportunities available for this program.
        </div>
      </div>
    </div>
  </div>
</template>
